/**
 * Lit une couleur de la palette depuis les variables CSS.
 *
 * Les cartes Leaflet dessinent en JavaScript : elles ne peuvent pas utiliser les classes
 * Tailwind. Plutôt que d'y recopier un hex — qui survit aux changements de ville et finit
 * par trahir le gabarit d'origine — on lit le jeton déclaré dans `index.css`.
 */
export function token(name: string, fallback: string): string {
  if (typeof window === 'undefined') return fallback
  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim()
  return value || fallback
}
